/* eslint-disable react/jsx-no-constructed-context-values */
import { createContext, useState } from 'react';

const userContext = createContext('');

export default userContext;
